import { render } from "./SecurityCode.vue?vue&type=template&id=4a47ab4e&scoped=true"
import script from "./SecurityCode.vue?vue&type=script&lang=js"
export * from "./SecurityCode.vue?vue&type=script&lang=js"

import "./SecurityCode.vue?vue&type=style&index=0&id=4a47ab4e&scoped=true&lang=css"
import "./SecurityCode.vue?vue&type=style&index=1&id=4a47ab4e&lang=css"

import exportComponent from "/home/runner/work/medsien-patient-app/medsien-patient-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a47ab4e"]])

export default __exports__